customElements.get("review-nuggets") || customElements.define("review-nuggets", class extends HTMLElement {
  constructor() {
    super(), this.config = {
      isAutoplay: "true" === this.getAttribute("data-autoplay"),
      autoplayInterval: 1e3 * parseInt(this.getAttribute("data-speed")) || 5e3,
      limit: parseInt(this.getAttribute("data-limit")) || 8,
      displayType: this.getAttribute("data-display-type") || "random",
      isReviewsIoEnabled: "true" === this.getAttribute("data-reviews-io-enabled"),
      sku: this.getAttribute("data-sku") || "",
      minRating: parseFloat(this.getAttribute("data-min-rating")) || null,
      types: this.getAttribute("data-types") || null,
      branch: this.getAttribute("data-branch") || null,
      tags: this.getAttribute("data-tags") || null
    }, this.index = 0, this.autoplayTimer = null, this.autoplayStartTime = null, this.autoplayPausedTime = null, 
    this.textBlocksEl = this.querySelector('[id^="TextBlocks-"]'), this.controlsEl = this.querySelector('[id^="Controls-"]'), 
    [ "update", "handleClick", "nextSlide", "startAutoplay", "scheduleNextSlide", "stopAutoplay", "pauseAutoplay", "resumeAutoplay" ].forEach(t => {
      this[t] = this[t].bind(this);
    });
  }
  get slideElements() {
    return this._slideElements || (this._slideElements = this.textBlocksEl.querySelectorAll("[data-slide]"));
  }
  get buttonsEl() {
    return this._buttonsEl || (this._buttonsEl = this.controlsEl.querySelectorAll("button"));
  }
  refreshElements() {
    this._slideElements = null, this._buttonsEl = null;
  }
  update(t) {
    const e = this.index;
    void 0 !== t && (this.index = t);
    const i = this.slideElements, s = this.buttonsEl;
    i.length && i[e] && i[this.index] && (i[e].classList.add("opacity-0", "pointer-events-none"), 
    i[this.index].classList.remove("opacity-0", "pointer-events-none"), [ i[e], i[this.index] ].forEach((t, e) => {
      const i = 1 === e;
      t.setAttribute("aria-hidden", !i), t.setAttribute("aria-current", i);
    }), s.length && s[e] && s[this.index] && (s[e].setAttribute("aria-current", "false"), 
    s[this.index].setAttribute("aria-current", "true"), s[e].removeAttribute("disabled"), 
    s[this.index].setAttribute("disabled", "true")));
  }
  handleClick(t, e) {
    t.preventDefault(), this.config.isAutoplay && (this.buttonsEl[this.index].classList.remove("rn-buttons__button--paused"), 
    this.stopAutoplay(), this.startAutoplay()), this.update(e);
  }
  nextSlide() {
    this.update((this.index + 1) % this.slideElements.length);
  }
  startAutoplay() {
    this.config.isAutoplay && (this.autoplayStartTime = Date.now(), this.scheduleNextSlide());
  }
  scheduleNextSlide() {
    this.config.isAutoplay && (this.autoplayTimer = setTimeout(() => {
      this.nextSlide(), this.autoplayStartTime = Date.now(), this.scheduleNextSlide();
    }, this.config.autoplayInterval));
  }
  stopAutoplay() {
    clearTimeout(this.autoplayTimer), this.autoplayTimer = this.autoplayStartTime = this.autoplayPausedTime = null;
  }
  pauseAutoplay() {
    if (!this.config.isAutoplay || !this.autoplayTimer) return;
    const t = this.buttonsEl[this.index];
    t && t.classList.add("rn-buttons__button--paused"), this.autoplayPausedTime = Date.now(), 
    clearTimeout(this.autoplayTimer), this.autoplayTimer = null;
  }
  resumeAutoplay() {
    if (!this.config.isAutoplay || !this.autoplayPausedTime) return;
    const t = this.buttonsEl[this.index];
    t && t.classList.remove("rn-buttons__button--paused");
    const e = this.autoplayPausedTime - this.autoplayStartTime, i = Math.max(0, this.config.autoplayInterval - e);
    this.autoplayTimer = setTimeout(() => {
      this.nextSlide(), this.autoplayStartTime = Date.now(), this.scheduleNextSlide();
    }, i), this.autoplayPausedTime = null;
  }
  async render(t) {
    const e = this.textBlocksEl.querySelector("template");
    if (!e) return;
    "random" === this.config.displayType && (t = [ t[Math.floor(Math.random() * t.length)] ]);
    const i = document.createDocumentFragment();
    if (t.forEach(t => {
      if (!t.text?.trim()) return;
      const s = e.content.cloneNode(!0);
      s.querySelector("li > figure > blockquote > div").textContent = `"${t.text}"`, i.appendChild(s);
    }), this.textBlocksEl.appendChild(i), "fading-carousel" === this.config.displayType) {
      const e = this.controlsEl.querySelector("template");
      if (e) {
        const i = document.createDocumentFragment();
        t.forEach(() => {
          i.appendChild(e.content.cloneNode(!0));
        }), this.controlsEl.appendChild(i);
      }
    }
  }
  async fetch() {
    const t = "random" !== this.config.displayType ? this.config.limit - this.slideElements.length : 32;
    if (!window.Shopify?.app_config?.reviews_io?.store || t < 1) return !1;
    try {
      const e = new URL("https://api.reviews.io/review-nuggets/data"), i = {
        store: window.Shopify.app_config.reviews_io.store,
        per_page: t
      };
      this.config.sku && this.config.sku.split(",").forEach(t => e.searchParams.append("sku[]", t.trim())), 
      this.config.minRating && (i.min_rating = this.config.minRating), this.config.types && (i.types = "all" === this.config.types ? "store_review,product_review" : this.config.types), 
      this.config.branch && (i.branch = this.config.branch), this.config.tags && this.config.tags.split(",").forEach(t => e.searchParams.append("tags[]", t.trim())), 
      Object.entries(i).forEach(([t, i]) => {
        null !== i && e.searchParams.append(t, i);
      });
      const s = await fetch(e, {
        headers: {
          accept: "application/json"
        }
      });
      if (!s.ok) throw new Error(`HTTP error! status: ${s.status}`);
      const {data: a} = await s.json();
      return !!a?.length && (await this.render(a), !0);
    } catch (t) {
      return console.error("Error fetching review nuggets:", t), !1;
    }
  }
  initializeSlides() {
    this.refreshElements();
    const t = this.slideElements;
    if (!t.length) return this.style.cssText = "display: none; margin: 0;", !1;
    this.style.cssText = "";
    const e = "random" === this.config.displayType ? Math.floor(Math.random() * t.length) : 0;
    return [ "first", "random" ].includes(this.config.displayType) || t.length < 2 ? (this.update(e), 
    this.setSlideHeight(), this.setAriaLabels(), !0) : (this.trimExcessElements(), this.refreshElements(), 
    this.controlsEl.style.display = null, this.setupEventListeners(), this.update(e), 
    this.setSlideHeight(), this.setAriaLabels(), this.config.isAutoplay && (this.stopAutoplay(), 
    this.startAutoplay()), !0);
  }
  setSlideHeight() {
    const t = this.slideElements, e = "fading-carousel" === this.config.displayType ? Math.max(...Array.from(t).map(t => t.offsetHeight)) : t[this.index].offsetHeight;
    this.textBlocksEl.style.height = `${e}px`;
  }
  setAriaLabels() {
    const t = this.slideElements, e = window.strings?.general?.slider?.of || "of", i = window.strings?.review_nuggets?.load_review || "Load review";
    t.forEach((i, s) => {
      i.setAttribute("aria-hidden", s !== this.index), i.setAttribute("aria-current", s === this.index), 
      i.setAttribute("aria-label", `${s + 1} ${e} ${t.length}`);
    }), this.buttonsEl.forEach((s, a) => {
      s.setAttribute("aria-label", `${a + 1} ${i} ${e} ${t.length}`);
    });
  }
  trimExcessElements() {
    const t = this.slideElements, e = this.buttonsEl;
    if (t.length > this.config.limit) {
      for (let e = this.config.limit; e < t.length; e++) t[e].remove();
      for (let t = this.config.limit; t < e.length; t++) e[t].remove();
    }
  }
  setupEventListeners() {
    this.buttonsEl.forEach(t => {
      const e = t.cloneNode(!0);
      t.parentNode.replaceChild(e, t);
    }), this.refreshElements(), this.buttonsEl.forEach((t, e) => {
      t.addEventListener("click", t => this.handleClick(t, e)), t.addEventListener("mouseenter", this.pauseAutoplay), 
      t.addEventListener("mouseleave", this.resumeAutoplay);
    }), this.textBlocksEl.addEventListener("mouseenter", this.pauseAutoplay), this.textBlocksEl.addEventListener("mouseleave", this.resumeAutoplay);
  }
  async connectedCallback() {
    const {displayType: t, isReviewsIoEnabled: e} = this.config;
    "fading-carousel" === t ? (this.initializeSlides(), e && await this.fetch() && this.initializeSlides()) : "first" === t ? (this.refreshElements(), 
    this.slideElements.length > 0 || e && await this.fetch() ? this.initializeSlides() : this.style.cssText = "display: none; margin: 0;") : e ? (await this.fetch(), 
    this.initializeSlides()) : this.initializeSlides();
  }
  disconnectedCallback() {
    this.stopAutoplay(), this.textBlocksEl.removeEventListener("mouseenter", this.pauseAutoplay), 
    this.textBlocksEl.removeEventListener("mouseleave", this.resumeAutoplay), this.buttonsEl.forEach(t => {
      t.removeEventListener("mouseenter", this.pauseAutoplay), t.removeEventListener("mouseleave", this.resumeAutoplay);
    });
  }
});